"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importStar(require("react"));
const react_2 = require("@osmosys/react");
const hooks_1 = require("../../hooks");
const reactstrap_1 = require("reactstrap");
const apollo_utilities_1 = require("apollo-utilities");
const ConverterTab_1 = require("./ConverterTab");
const ConverterTabBody_1 = require("./ConverterTabBody");
// import { useQuery } from '@apollo/react-hooks';
// import { contentMapping } from '../../../../graphql';
exports.EmailCanvasConverterPanelTab = ({ conversionStatus, displayName, idxPath, block, setConversionStatus, onChange, value, linkToPost, }) => {
    var _a, _b, _c;
    const { dispatchCanvasAction } = hooks_1.useEmailCanvasUpdate();
    const { state: { conversionPanelConversions, activeConversionBlockIdx }, } = hooks_1.useEmailCanvasContext();
    const activeIsSet = !!activeConversionBlockIdx;
    const isActive = activeConversionBlockIdx === idxPath;
    const finished = conversionStatus && (conversionStatus.success || conversionStatus.error);
    react_1.useEffect(() => {
        const newConversionPanelConversions = Object.assign(Object.assign({}, conversionPanelConversions), { [idxPath]: conversionStatus });
        if (!apollo_utilities_1.isEqual(newConversionPanelConversions, conversionPanelConversions)) {
            dispatchCanvasAction({
                data: {
                    conversionPanelConversions: newConversionPanelConversions,
                },
                type: 'state',
            });
        }
    }, [conversionStatus, conversionPanelConversions]);
    const conversions = react_1.useMemo(() => {
        var _a, _b, _c;
        return (_c = (_b = (_a = block) === null || _a === void 0 ? void 0 : _a.contentFeed) === null || _b === void 0 ? void 0 : _b.contentMapping) === null || _c === void 0 ? void 0 : _c.conversions;
    }, [(_c = (_b = (_a = block) === null || _a === void 0 ? void 0 : _a.contentFeed) === null || _b === void 0 ? void 0 : _b.contentMapping) === null || _c === void 0 ? void 0 : _c.conversions]);
    const onStart = react_1.useCallback(() => {
        setConversionStatus('loading');
    }, [setConversionStatus]);
    const onError = react_1.useCallback(() => {
        setConversionStatus('error');
    }, [setConversionStatus]);
    const onSuccess = react_1.useCallback(html => {
        onChange(html);
        setConversionStatus('success');
    }, [setConversionStatus]);
    const onStop = react_1.useCallback(() => {
        setConversionStatus('stopped');
    }, [setConversionStatus]);
    const onClose = react_1.useCallback(() => {
        window.alert('close');
    }, []);
    const tab = (react_1.default.createElement(ConverterTab_1.EmailCanvasConverterTab, { isActive: isActive, idxPath: idxPath, dispatchCanvasAction: dispatchCanvasAction, activeIsSet: activeIsSet, activeConversionBlockIdx: activeConversionBlockIdx, finished: finished, conversionStatus: conversionStatus, displayName: displayName }));
    const body = (react_1.default.createElement(ConverterTabBody_1.EmailCanvasConverterTabBody, { onStart: onStart, onSuccess: onSuccess, onError: onError, onClose: onClose, onChange: onChange, showSpinner: isActive, conversions: conversions, run: conversionStatus.loading && !conversionStatus.success, onStop: onStop, linkToPost: linkToPost, contentStr: value }));
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.Portal, { elementID: "email-canvas-convert-panel-tabs" }, tab),
        react_1.default.createElement(react_2.Portal, { elementID: "email-canvas-convert-panel-body" },
            react_1.default.createElement(reactstrap_1.Collapse, { isOpen: activeConversionBlockIdx === idxPath }, body))));
};
//# sourceMappingURL=ConverterPanelTab.js.map